module.exports = __webpack_public_path__ + "static/media/deities5.7998d222.jpeg";